export * from "./urlCopyright";
export * from "./urlPrivacyPolicy";
export * from "./urlTermsOfService";
